import { api, BASE_URL, getToken } from './client';

/**
 * Sodra declarations (2026-09-13): SAM (monthly employer/insured), 1-SD
 * (hires), 2-SD (dismissals). Generated from the read-only mirrors; the
 * workflow (Draft → UnderReview → Approved → Locked) is a5suite-plane state.
 */

export interface SodraDeclarationRowDto {
  rowNumber: number;
  personId: number;
  personCode: string;
  personName: string;
  income: number;
  payment: number;
  taxRate: number | null;
  extras?: Record<string, string> | null;
}

export interface SodraDeclarationDto {
  declarationType: 'SAM' | 'SD1' | 'SD2';
  year: number | null;
  month: number | null;
  dateFrom: string | null;
  dateTo: string | null;
  personCount: number;
  totalIncome: number;
  totalPayments: number;
  rows: SodraDeclarationRowDto[];
  warnings: string[];
}

export interface SodraDeclarationHeaderDto {
  id: number;
  declarationType: string;
  year: number | null;
  month: number | null;
  dateFrom: string | null;
  dateTo: string | null;
  status: string;
  statusLabel: string;
  personCount: number;
  totalIncome: number;
  totalPayments: number;
  generatedAt: string;
  approvedAt: string | null;
  approvedBy: string | null;
  lockedAt: string | null;
  lockedBy: string | null;
  formCode: string;
}

export interface SodraDeclarationDetailDto extends SodraDeclarationHeaderDto {
  submittedBy: string | null;
  lines: {
    rowNumber: number;
    personId: number;
    personCode: string;
    personName: string;
    income: number;
    payment: number;
    taxRate: number | null;
    rowJson: string | null;
  }[];
}

export type SodraGenerateParams =
  | { type: 'SAM'; year: number; month: number }
  | { type: 'SD1'; from: string; to: string }
  | { type: 'SD2'; from: string; to: string; accrualYear?: number; accrualMonth?: number };

export const sodraApi = {
  generate: (params: SodraGenerateParams) =>
    api.post<SodraDeclarationDto>('/sodra-declarations/generate', params),

  save: (params: SodraGenerateParams) =>
    api.post<{ id: number }>('/sodra-declarations/save', params),

  list: () => api.get<SodraDeclarationHeaderDto[]>('/sodra-declarations'),

  getById: (id: number) => api.get<SodraDeclarationDetailDto>(`/sodra-declarations/${id}`),

  action: (id: number, action: 'submit' | 'approve' | 'lock' | 'reject', actor?: string) =>
    api.post<void>(`/sodra-declarations/${id}/action`, { action, actor: actor ?? null }),

  /** CSV download (blob, UTF-8 BOM). */
  exportCsv: async (id: number, fileName: string): Promise<void> => {
    const headers: Record<string, string> = { Accept: 'text/csv' };
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const response = await fetch(`${BASE_URL}/sodra-declarations/${id}/export`, {
      headers,
      credentials: 'include',
    });
    if (!response.ok) throw new Error(`Eksportas nepavyko (${response.status})`);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    try {
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } finally {
      URL.revokeObjectURL(url);
    }
  },
};
